var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-sm-12 col-md-8 mb-0" },
      [_c("title-bread-crumb", { attrs: { page: _vm.page } })],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "col-sm-12 col-md-4 d-flex justify-content-end align-items-center actions text-right"
      },
      [
        _vm.onReturn
          ? _c("action-button", {
              staticClass: "mx-2",
              attrs: {
                i: "fas fa-arrow-circle-left",
                text: "Regresar",
                variant: "outline-success"
              },
              on: { click: _vm.onReturn }
            })
          : _vm._e(),
        _vm.onAdd
          ? _c("action-button", {
              staticClass: "mx-2",
              attrs: {
                i: "fas fa-file-plus pr-1",
                text: "Añadir",
                variant: "success"
              },
              on: { click: _vm.onAdd }
            })
          : _vm._e(),
        _vm.onSave
          ? _c("action-button", {
              staticClass: "mx-2",
              attrs: {
                i: "fas fa-save pr-1",
                text: "Guardar",
                variant: "success"
              },
              on: { click: _vm.onSave }
            })
          : _vm._e(),
        _vm._l(_vm.actions, function(action) {
          return _c(
            "div",
            { key: action.name },
            [
              action.visible || action.visible == null
                ? _c(action.component || "ActionButton", {
                    tag: "component",
                    class: action.class || "mx-2",
                    attrs: {
                      i: action.icon,
                      text: action.text,
                      variant: action.variant
                    },
                    on: {
                      click: function($event) {
                        return _vm.$eventHandler(action.click)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        _vm._t("default")
      ],
      2
    ),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 p-0" }, [
      _c("div", { staticClass: "dropdown-divider mt-0 pb-2 w-100 mb-4" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }